import { performLogout } from "../utils/performLogout";

const useLogout = () => {
	const logout = async () => {
		await performLogout();
	};

	return logout;
};

export default useLogout;
